<template lang="pug">
  #ReservationIndex.overflow-hidden
    .content-header.bg-secondary.rounded-bottom-1rem.d-flex.align-items-center
      h5.mb-0 我的顧客
    .container-width.position-relative
      .w-100.overflow-hidden
        .p-3
          b-row(
            no-gutters
            class="mb-2 align-items-start"
          )
            b-col(
              cols=3,
              class="align-items-center"
            )
              ProfilePhotoSticker.ProfilePhotoSticker.d-flex.align-items-start.justify-content-start.border.border-black(
                :profileUrl="memberInfo ? memberInfo.picture_url : 'xxx'",
                :style="{ 'width': '60px', 'height': '60px' }"
              )
              .text-center.mt-3
                b-button.font-weight-bold.btn-custom(
                  size="sm",
                  variant="remind",
                  @click="updateMemberInfoHandler()",
                  style="border: 0.3rem solid #fff;border-radius: 50px;padding: 5px;border: 3px solid #000;box-shadow: 0.05rem 0.15rem 0 #00000033;"
                )
                  span 資料刷新
            b-col(
              cols=9
            )
              .ml-1
                p.mb-1.font-weight-bold {{ memberInfo ? `${memberInfo.line_display_name}` : '' }}
                p.mb-1.d-flex.align-items-center
                  b-input.d-inline-block(
                    v-model="noteName",
                    :disabled="!editMode",
                    style="border-radius: 20px;",
                    :style="{ 'background-color: #eee;border-0': !editMode, 'background-color: #fff;border-black': editMode }"
                    placeholder="顧客備註名"
                  )
                  b-button.rounded-50.d-flex.align-items-center.justify-content-center.mx-2.button.iconBtn.iconEditBtn.border-black.border-width-lg(
                    variant="remind",
                    @click="editModeHandler()"
                  )
                    i.fas.fa-pencil-alt.iconEdit
                p.mb-0.font-weight-bold MARSID：
                  span.mb-0(
                    v-if="memberInfo && memberInfo.mars_id"
                  ) {{ memberInfo.mars_id }}
                p.mb-0.font-weight-bold(v-if="memberInfo") 會籍：{{ memberInfo.card_type }}
                p.mb-0.font-weight-bold(v-if="memberInfo") 會籍到期日：{{ memberInfo.card_expire_date }}
                p.mb-0.font-weight-bold(v-if="memberInfo") 生日：{{ memberInfo.birthday }}
                p.mb-0.font-weight-bold(v-if="memberInfo") 本月/下月/下下月到期點數：<br>{{ memberInfo.expire_point_current_month }}/{{ memberInfo.expire_point_next_month }}/{{ memberInfo.expire_point_next2_month }}
                small.red (提醒) 顧客資訊請勿截圖外流
        b-row.flex-nowrap.no-gutters.px-3(
          style="border-bottom: 0.2rem solid #000; overflow-y: auto;"
        )
          b-col.px-2(
            cols=4
          )
            b-button(
              block,
              :variant=" nowSelectItem === '客戶資料' ? 'primary' : 'gray-light-3 text-black' ",
              @click="changeTypeHandler('客戶資料')",
              style="border-radius: .8rem .8rem 0 0;font-weight: bold; height: 100%;"
            ) 客戶資料
          b-col.px-2(
            cols=4
          )
            b-button(
              block,
              :variant=" nowSelectItem === '預約紀錄' ? 'primary' : 'gray-light-3 text-black' ",
              @click="changeTypeHandler('預約紀錄')",
              style="border-radius: .8rem .8rem 0 0;font-weight: bold; height: 100%;"
            ) 預約紀錄
          b-col.px-2(
            cols=4
          )
            b-button(
              block,
              :variant=" nowSelectItem === '優惠券' ? 'primary' : 'gray-light-3 text-black' ",
              @click="changeTypeHandler('優惠券')",
              style="border-radius: .8rem .8rem 0 0;font-weight: bold; height: 100%;"
            ) 優惠券
          b-col.px-2(
            cols=4
          )
            b-button(
              block,
              :variant=" nowSelectItem === '集點卡'|| nowSelectItem === '集點狀態' ? 'primary' : 'gray-light-3 text-black' ",
              @click="changeTypeHandler('集點卡')",
              style="border-radius: .8rem .8rem 0 0;font-weight: bold; height: 100%;"
            ) 集點卡
          b-col.px-2(
            cols=4
          )
            b-button(
              block,
              :variant=" nowSelectItem === '訂單資料' ? 'primary' : 'gray-light-3 text-black' ",
              @click="changeTypeHandler('訂單資料')",
              style="border-radius: .8rem .8rem 0 0;font-weight: bold; height: 100%;"
            ) 訂單資料
        .customerInfo.p-3.mb-3.h-100(
          v-show="nowSelectItem === '客戶資料'"
        )
          p.mb-1 顧客喜好：
          multiselect.mb-3(
            v-model="userLabels",
            tag-placeholder="新增顧客喜好",
            placeholder="輸入文字新增顧客喜好",
            selectLabel="點擊新增顧客喜好",
            deselectLabel="點擊移除顧客喜好",
            selectedLabel="已選擇",
            label="tag_name",
            track-by="tag_key",
            group-values="tag",
            group-label="group",
            :options="tagsOption",
            :multiple="true",
            :taggable="true",
            @tag="addLabelHandler",
            @remove="removeLabelHandler",
            @select="selectLabelHandler"
            noOptions="無顧客喜好"
          )
            template(slot="Label", slot-scope='{ tags }')
            template(slot="noOptions")
              strong 請按 Enter 新增顧客喜好
          p.mb-1 顧客描述：
          b-textarea.border-0(
            v-model="desc",
            class="mb-2",
            max-rows="8",
            style="background: #eee;border-radius: 20px;"
          )
          .text-center
            b-button.font-weight-bold.py-1.px-5.btn-custom(
              size="sm",
              variant="remind",
              @click="updateDescriptionHandler()",
              style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.15rem 0.15rem 0 #00000033;"
            ) 儲存
        .reservationInfo.mb-3(
          v-show="nowSelectItem === '預約紀錄'"
        )
          .p-3
            b-card.border-0.mb-2.customerCard.overflow-hidden(
              bg-variant="white",
              v-for="(reservation,index) in reservations",
              :key="reservation.id",
              v-if="reservations"
            )
              .reserveAtRow.mb-2.d-flex.align-items-center
                small 預約時間：{{ reservation.RegisterDate }}
              .typeRow.mb-2.d-flex.align-items-center
                small 服務內容：{{ reservation.CampaignName }}
              .sourceRow.mb-3.d-flex.align-items-center
                small 來源：Line
              b-row(
                no-gutters,
                class="d-flex justify-content-center",
              )
                b-col(
                  :cols="4"
                )
                  button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
                    size="sm",
                    variant="primary",
                    @click="cancelReservationModalShowHandler(reservation)",
                    style="border: 0.4rem solid #fff;border-radius: 50px;padding: 0px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
                  ) 取消預約
              .labelTag(
                v-if="reservation.status === 'expired'",
                style="right: 0;bottom: 0;"
              )
                span.labelTag__text 已過期
            p.mb-0.text-center(
              v-if="reservations.length === 0"
            ) 無預約資料
        .couponInfo.mb-3(
          v-show="nowSelectItem === '優惠券'"
        )
          .col-12.mb-1.pt-2
            .border-0.mb-1(
              v-for="(item, index) in coupons",
              :key="index",
            )
              .p-2.no-gutters.border-bottom.border-black
                p.mb-0.font-weight-bold.f17 {{ item.title }}
                p.mb-0.text-gray {{ item.endTime }}
            p.mb-0.text-center(
              v-if="coupons.length === 0"
            ) 無優惠券資料
        .pointsActivityInfo.mb-3.p-2(
          v-if="nowSelectItem === '集點卡'"
        )
          b-card.m-3.border-black.custom-shadow(
            bg-variant="light",
            v-for="(item, index) in memberPointsList",
            :key="item.id"
            @click="changeTypeHandler('集點狀態', item.id)"
          )
            h6.mb-1 {{ item.title }}

          .col-12.mb-1.pt-2
            p.mb-0.text-center(
              v-if="memberPointsList.length === 0"
            ) 無參與集點卡活動
        .pointsSatusInfo.mb-3.p-2(
          v-show="nowSelectItem === '集點狀態'"
        )
          .col-12.mb-1.pt-2
            div.d-flex.align-items-center.justify-content-between
              b-button.rounded-50.d-flex.align-items-center.justify-content-center.mx-2.button.iconBtn.iconEditBtn.border-black.border-width-lg(
                variant="remind",
                @click="changeTypeHandler('集點卡')"
              )
                i.fas.fa-arrow-left
              b-button.border-black.border-width-lg.btn-sm(v-b-modal.member-points-demo-modal, variant="remind") 集點卡 Demo 頁面
            .border-0.m-3(
              v-for="(item, index) in memberPointsStatus",
              :key="item.point_collection_template_mission_id",
            )
              .row.p-2.border-bottom.border-black
                .col-9.d-flex.align-items-center.pr-0
                  span.font-weight-bold 任務{{index+1}}：{{ item.point_collection_template_mission_name }}
                .col-3.d-flex.align-items-center.justify-content-end
                  span(
                    :class="{'text-danger': !item.is_clear, 'text-grey': item.is_clear}"
                  ) {{item.is_clear ? '已達成':'未達成'}}
        .orderInfo.mb-3(
          v-show="nowSelectItem === '訂單資料'"
        )
          .p-3
            .position-relative(v-if="purchaseList.length > 0" v-for="(node, nodeIdx) in purchaseList" :key="node.sourceOrderNumber")
              .order
                div {{ (node.order_date).slice(0, 10) }}
                div {{ node.sourceOrderNumber }} | {{ node.salesRepId }}
                .d-flex.justify-content-between
                  div 小計：
                  div NT$ {{ filterMoney(node.amountWithTax) }}
              .detail
                .toggle.h5(v-b-toggle="node.sourceOrderNumber")
                  b-icon-plus-circle
                  b-icon-dash-circle
                b-collapse.mt-2(:id="node.sourceOrderNumber")
                  .item.mb-2.d-flex.justify-content-between.align-items-center(v-for="(item, itemIdx) in node.purchaseItems" :key="`${item.productName}${itemIdx}`")
                    img(:src="getProductImage(item.productImageUrl)" alt="產品圖" @error="onImageError")
                    div.w-50 {{ item.productName }}
                    .price.align-self-end NT$ {{ filterMoney(item.sellingPriceWithTax) }}
              hr
            p.text-center(v-if="purchaseList.length === 0") 無訂單資料

    b-button.position-fixed.p-1.btn-custom(
      variant="remind",
      @click="goToChatRoomHandler()",
      style="right: 15px;bottom: 80px;border: 0.4rem solid #fff;border-radius: 50px;padding: 10px;border: 4px solid #000;box-shadow: 0.15rem 0.15rem 0 #00000033;"
    )
      i.custom.icon-main_bottomMenu_chat

    b-modal#reservation-cancel-modal(
      title="請填寫預約人資訊",
      centered,
      scrollable,
      hide-header,
      hide-footer,
      v-model="reservationCancelModalShow"
    )
      h5.text-center.mb-3 請填寫預約人資訊
      b-form-input.mb-3.border-black.border-width-lg(
        id="name",
        type="text",
        required,
        trim,
        v-model="reservationCancelForm.register_name",
        placeholder="姓名"
      )
      b-form-input.mb-3.border-black.border-width-lg(
        id="mobile",
        type="tel",
        required,
        trim,
        v-model="reservationCancelForm.register_phone",
        placeholder="手機"
      )
      .row.no-gutters
        .col-6.pr-2
          button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
            type="button",
            @click="reservationCancelModalShow = false",
            style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
          ) 取消
        .col-6.pl-2
          button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
            type="button",
            @click="cancelReservationHandler()",
            style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
          ) 確認

    b-modal#member-points-demo-modal(
      centered,
      scrollable,
      title="集點卡 Demo"
      header-class="p-2"
      body-class="p-0"
      hide-footer,
    )
      div(v-if="!memberPointsDemoImageUrl") 無圖片
      div(v-else)
        img(:src="memberPointsDemoImageUrl", alt="")
</template>

<script>
import { mapState } from 'vuex';
import { BIcon, BIconPlusCircle, BIconDashCircle } from 'bootstrap-vue'
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { SA_MY_CUSTOMER_RESERVATION_EDIT } from '@/router/sa/my-customer';
import { SA_CHAT_ROOM_INDEX } from '@/router/sa/chat-room';
import defaultProductImgUrl from '@/assets/images/default/defaultProductImg_HR.png';

export default {
  name: 'ReservationIndex',
  components: {
    BIcon,
    BIconPlusCircle,
    BIconDashCircle,
    ProfilePhotoSticker,
    InfiniteLoading
  },
  props: {
    userId: {
      type: [String, Number],
      required: true
    },
    activity: { //從不同功能來的
      type: [String, Number]
    },
  },
  data() {
    return {
      nowSelectItem: '客戶資料',
      infiniteId: +new Date(),
      noteName: null,
      desc: null,
      editMode: false,
      userLabels: [],
      tagsOption: [],
      reservationCancelModalShow: false,
      reservationCancelForm: {
        member_uuid: null,
        campaign_code: null,
        register_date: null,
        register_section: null,
        register_name: null,
        register_phone: null
      },
      memberPointsDemoImageUrl: "",
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.commit('sa_my_customer/resetHandler');
    vm.$store.commit('toggleLoading', false);

    // 取得顧客詳細資料
    vm.$store.dispatch('sa_my_customer/getMemberDetailHandler', vm.userId)
      .then(() => {
        vm.$set(vm, 'noteName', vm.memberInfo.note_name);
        vm.$set(vm, 'desc', vm.memberInfo.desc);
        // 取得所有標籤
        vm.$store.dispatch('sa_my_customer/getTagsHandler')
          .then(() => {
            vm.$set(vm, 'tagsOption', vm.tags);
            // 取得該使用者的標籤
            vm.$store.dispatch('sa_my_customer/getMemberTagsHandler', vm.memberInfo.member_line_uuid)
              .then(() => {
                vm.$set(vm, 'userLabels', vm.memberTags);
                vm.$swal.close();
              });
          });
      });
      if(vm.activity) { //從不同功能來的-> 到不同的tab
        switch (vm.activity) {
          case 'points_card':
              vm.changeTypeHandler('集點卡');
            break;
          default:
            break;
        }
     }
  },
  methods: {
    infiniteHandler(activityId) {
      const vm = this;
      //取得預約紀錄
      if(vm.nowSelectItem === '預約紀錄') {
        vm.$swal.fire({
          title: '取得預約中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });
        vm.$store.dispatch('sa_my_customer/getReservationByIDHandler', {
          m_id: vm.userId
        })
          .then(() => {
            vm.$swal.close();
          });
        return
      }
      //取得優惠券紀錄
      if(vm.nowSelectItem === '優惠券') {
        vm.$swal.fire({
          title: '取得優惠券中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });
        vm.$store.dispatch('sa_my_customer/getCouponByIDHandler', vm.userId)
          .then(() => {
            vm.$swal.close();
          });
        return
      }
      //取得集點卡活動
      if(vm.nowSelectItem === '集點卡') {
        vm.$swal.fire({
          title: '取得集點卡中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });
        vm.$store.dispatch('sa_points_card/getMemberPointsHandler', {member_uuid: vm.memberInfo.member_line_uuid})
          .then(() => {
            vm.$swal.close();
        });
         return
      }
      //取得集點卡任務狀態
      if(vm.nowSelectItem === '集點狀態') {
        vm.$swal.fire({
          title: '取得集點狀態中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });
        vm.$store.dispatch('sa_points_card/getMemberPointsStatusHandler', {point_collection_id: activityId, member_uuid: vm.memberInfo.member_line_uuid})
          .then(() => {
            vm.$swal.close();
        });
         return
      }
      // 取得訂單資料
      if(vm.nowSelectItem === '訂單資料') {
        vm.$swal.fire({
          title: '取得訂單資料中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });
        vm.$store.dispatch('sa_my_customer/getMemberOrdersHandler', vm.userId)
          .then(() => {
            vm.$swal.close();
        });
         return
      }
    },
    changeTypeHandler(type, activityId) {
      const vm = this;
      switch (type) {
        case '客戶資料':
          if (vm.nowSelectItem === '客戶資料') return;
          vm.nowSelectItem = '客戶資料';
          break;
        case '預約紀錄':
          if (vm.nowSelectItem === '預約紀錄') return;
          vm.nowSelectItem = '預約紀錄';
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteHandler();
          break;
        case '優惠券':
          if (vm.nowSelectItem === '優惠券') return;
          vm.nowSelectItem = '優惠券';
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteHandler();
          break;
        case '集點卡':
          if (vm.nowSelectItem === '集點卡') return;
          vm.nowSelectItem = '集點卡';
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteHandler();
          break;
        case '集點狀態':
          if (vm.nowSelectItem === '集點狀態') return;
          vm.nowSelectItem = '集點狀態';
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteHandler(activityId);
          vm.memberPointsDemoImageUrl = vm.memberPointsList.find(
            (item) => item.id === activityId
          ).demo_image_url;
          break;
        case '訂單資料':
          if (vm.nowSelectItem === '訂單資料') return;
          vm.nowSelectItem = '訂單資料';
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteHandler();
          break;
        default:
          break;
      }
    },
    editModeHandler() {
      const vm = this;
      if (!vm.editMode) {
        vm.editMode = true;
      } else {
        vm.$swal.fire({
          title: '備註名儲存中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            vm.$swal.showLoading();
          }
        });

        vm.$store.dispatch('sa_my_customer/updateMemberNoteNameHandler', {
          memberId: vm.memberInfo.member_id,
          note_name: vm.noteName
        })
          .then(() => {
            vm.$swal.close();
            vm.editMode = false;
          });
      }
    },
    async updateDescriptionHandler() {
      const vm = this;

      if (vm.editMode) {
        await vm.editModeHandler();
      }

      vm.$swal.fire({
        title: '顧客描述儲存中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });

      vm.$store.dispatch('sa_my_customer/updateMemberDescHandler', {
        memberId: vm.memberInfo.member_id,
        desc: vm.desc
      })
        .then(() => {
          vm.$swal.close();
          vm.editMode = false;
        });
    },
    cancelReservationModalShowHandler(reservation) {
      const vm = this;
      if (vm.reservationCancelModalShow) return;
      vm.reservationCancelForm = {
        member_uuid: vm.memberInfo.member_line_uuid,
        campaign_code: reservation.CampaignCode,
        register_date: reservation.RegisterDate,
        register_section: reservation.RegisterSection,
        register_name: reservation.Name,
        register_area: reservation.RegisterArea,
        register_counter: reservation.RegisterCounter,
        register_phone: reservation.Mobile
      };
      vm.reservationCancelModalShow = true;
    },
    cancelReservationHandler() {
      const vm = this;
      if (!vm.reservationCancelModalShow || !vm.reservationCancelForm.member_uuid || !vm.reservationCancelForm.campaign_code || !vm.reservationCancelForm.register_date || !vm.reservationCancelForm.register_section) {
        return;
      } else if (!vm.reservationCancelForm.register_name) {
        vm.$swal.fire({
          icon: 'error',
          title: '預約人姓名尚未填寫'
        });
      } else if (!vm.reservationCancelForm.register_phone) {
        vm.$swal.fire({
          icon: 'error',
          title: '預約人手機尚未填寫'
        });
      } else {
        vm.$swal.fire({
          title: '取消預約中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });
        vm.$store.dispatch('sa_my_customer/deleteHandler', vm.reservationCancelForm)
          .then(() => {
            vm.$swal.close();
            vm.reservationCancelModalShow = false;
            vm.$store.commit('sa_my_customer/resetHandler');
            vm.infiniteHandler();
          });
      }
    },
    editReservationHandler(reservation) {
      const vm = this;
      vm.$router.push({
        name: SA_MY_CUSTOMER_RESERVATION_EDIT,
        params: {
          id: reservation.reservation_id,
          userId: this.userId,
          editInfo: reservation
        }
      });
    },
    confirmReservationHandler(reservationId) {
      const vm = this;
      vm.$swal.fire({
        title: '預約確認中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sa_my_customer/checkHandler', {
        reservation_id: reservationId
      })
        .then(() => {
          vm.$swal.close();
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteId += 1;
        });
    },
    doneReservationHandler(reservationId) {
      const vm = this;
      vm.$swal.fire({
        title: '完成預約中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sa_my_customer/successHandler', {
        reservation_id: reservationId
      })
        .then(() => {
          vm.$swal.close();
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteId += 1;
        });
    },
    addLabelHandler(tag_name) {
      const vm = this;

      setTimeout(() => {
        vm.$swal.fire({
          title: '顧客喜好新增中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });
      }, 50);
      // 儲存
      vm.$store.dispatch('sa_my_customer/storeTagsHandler', {
        member_uuid: vm.memberInfo.member_line_uuid,
        tags: [
          {
            tag_name,
            type: 'new',
            tag_key: null,
            tag_id: null
          },
          ...vm.userLabels
        ]
      })
        .then(() => {
          // 初始化標籤
          vm.initTagsHandler();
          vm.$swal.close();
        });
    },
    removeLabelHandler(selectTag) {
      const vm = this;
      setTimeout(() => {
        vm.$swal.fire({
          title: '顧客喜好移除中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });
      }, 50);

      // 儲存
      setTimeout(() => {
        vm.$store.dispatch('sa_my_customer/storeTagsHandler', {
          member_uuid: vm.memberInfo.member_line_uuid,
          tags: vm.userLabels
        })
          .then(() => {
            // 初始化標籤
            vm.initTagsHandler();
            vm.$swal.close();
          });
      }, 50);
    },
    selectLabelHandler() {
      const vm = this;
      setTimeout(() => {
        vm.$swal.fire({
          title: '加上顧客喜好中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });
      }, 50);
      // 儲存
      setTimeout(() => {
        vm.$store.dispatch('sa_my_customer/storeTagsHandler', {
          member_uuid: vm.memberInfo.member_line_uuid,
          tags: vm.userLabels
        })
          .then(() => {
            // 初始化標籤
            vm.initTagsHandler();
            vm.$swal.close();
          });
      }, 50);
    },
    // 初始化標籤
    initTagsHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '標籤載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      // 取得所有標籤
      vm.$store.dispatch('sa_my_customer/getTagsHandler')
        .then(() => {
          vm.$set(vm, 'tagsOption', vm.tags);
          // 取得該使用者的標籤
          vm.$store.dispatch('sa_my_customer/getMemberTagsHandler', vm.memberInfo.member_line_uuid)
            .then(() => {
              vm.$set(vm, 'userLabels', vm.memberTags);
              vm.$swal.close();
            });
        });
    },
    goToChatRoomHandler() {
      const vm = this;
      vm.$router.push({
        name: SA_CHAT_ROOM_INDEX,
        params: {
          chatRoomTitle: `與${vm.memberInfo.display_name || vm.memberInfo.line_display_name}對話`,
          user: vm.memberInfo,
          sa_id: vm.sa_id
        }
      });
    },
    updateMemberInfoHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '資料刷新中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      const input = {
        cardNo: vm.memberInfo.mars_id
      }
      vm.$store.dispatch('sa_my_customer/updateMemberCardInfoHandler', input)
        .then(() => {
          vm.$store.dispatch('sa_my_customer/getMemberDetailHandler', vm.userId)
            .then(() => {
              vm.$swal.close();
            });
        });
    },
    getProductImage(url) {
      return url && url.trim() !== '' ? url : defaultProductImgUrl;
    },
    onImageError(event) {
      event.target.src = defaultProductImgUrl;
    },
  },
  computed: {
    ...mapState({
      sa_id: (state) => state.sa_profile.data.id,
      reservations: (state) => state.sa_my_customer.reservations,
      reservationTimeList: (state) => state.sa_my_customer.reservationTimeList,
      pagination: (state) => state.sa_my_customer.pagination,
      nowSelectStatus: (state) => state.sa_my_customer.nowSelectStatus,
      memberInfo: (state) => state.sa_my_customer.memberInfo,
      tags: (state) => state.sa_my_customer.tags,
      memberTags: (state) => state.sa_my_customer.memberTags,
      coupons: (state) => state.sa_my_customer.coupons,
      memberPointsList: (state) => state.sa_points_card.memberPointsList,
      memberPointsStatus: (state) => state.sa_points_card.memberPointsStatus,
      purchaseList: (state) => state.sa_my_customer.purchaseList,
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('sa_my_customer/resetHandler');
    next();
  }
};
</script>

<style lang="scss" scoped>
img {
  max-width: 100% !important;
  height: auto;
}
.card {
  border: 0.2rem solid #000!important;
  border-radius: 0.8rem;
  box-shadow: 0.2rem 0.2rem 0 #00000033;
  &-hasNews {
    &::after {
      content: "";
      position: absolute;
      right: 0.4rem;
      top: 0.4rem;
      background-color: #ef4852;
      width: 0.7rem;
      height: 0.7rem;
      border-radius: 50%;
    }
  }
}

.ProfilePhotoSticker {
  border: 0.2rem solid #000!important;
}

.red {
  color: #ef4852;
}
@font-face {
  font-family: "icon";
  src: url("../../../assets/fonts/icon.eot?hrpp7d");
  src: url("../../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

#header_back {
  font-size: 1.7rem;
  padding: 0.5rem;
  position: absolute;
  top: 3%;
  left: 1.6rem;
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  cursor: pointer;
  color: #fff !important;
  z-index: 15;
}

i.custom {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1.5rem;
}

.icon-main_bottomMenu_chat:before {
  content: "\e906";
}
.f17 {
  font-size: 17px;
}
.orderInfo .toggle {
  position: absolute;
  top: 0;
  right: 0;
}
.orderInfo .detail .item {
  font-size: 14px;
}
.orderInfo .detail .item img {
  width: 30%;
  max-width: 80px;
  aspect-ratio: 1;
}
.orderInfo .detail .item .price {
  width: 22%
}
.orderInfo .detail .toggle.collapsed .bi-plus-circle{
  display: block
}
.orderInfo .detail .toggle.collapsed .bi-dash-circle{
  display: none
}
.orderInfo .detail .toggle.not-collapsed .bi-plus-circle{
  display: none
}
.orderInfo .detail .toggle.not-collapsed .bi-dash-circle{
  display: block
}
</style>
